
import { CameraIcon } from "@heroicons/react/24/outline";
import { IPart } from '../../models/Part';
import { useMemo, useState } from "react";
import LoadingWheel from "../shared/LoadingWheel";

export default function PartImage({ part, width = "w-48" }: { part: IPart, width?: string }) {

  var image = useMemo(() => part.images?.find((image) => image.isThumbnail === true), [part.images]);

  const [hovered, setHovered] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [fullImageLoaded, setFullImageLoaded] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
    setFullImageLoaded(false);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  return (
    <>
      <span
        className="flex justify-center relative"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
      >
        {image ? (
          <img
            className={`${width} h-auto object-contain`}
            src={image.thumbnailUrl ?? image.url}
          />
        ) : (
          <CameraIcon className="w-14 text-gray-600" />
        )}
      </span>

      {/* Full-size hover image */}
      {hovered && image && (
        <div
          className="fixed pointer-events-none z-50"
          style={{
            top: mousePos.y + 10,
            left: mousePos.x + 10,
          }}
        >
          {!fullImageLoaded && (
            <div className="w-8 h-8">
            <LoadingWheel  />
            </div>
          )}
          <img
            src={image.url}
            className={`max-w-2xl max-h-xl border border-gray-300 shadow-lg rounded-md transition-opacity duration-300 ${
              fullImageLoaded ? "opacity-100" : "opacity-0"
            }`}
            onLoad={() => setFullImageLoaded(true)}
          />
        </div>
      )}
    </>
  );
}